export default {
    online: {
        img: 'https://web-data.zmlearn.com/image/rgfdfqKxoWJaosj82f3dxC/img_banner_text%402x.png',
        button: 'https://web-data.zmlearn.com/image/8jDaAArHya9Xz1BrJww9fd/btn_home_banner%402x.png',
    },
    class: {
        title: '<h1 ><span>Online 1-on-1 Class,</span><span><p>Anywhere</p> and<p> Anytime</p>!</span></h1>',
        list: [
            {
                id: 1,
                title: 'More Convenient',
                content: 'Only you need is your PC/iPad!',
                img: 'https://web-data.zmlearn.com/image/aL42CPHh86SkiwHZpkodwx/img_p1_pic1%402x.png',
            },
            {
                id: 2,
                title: 'More Efficient',
                content: 'Real-time class interaction and ready for Q&A during the class',
                img: 'https://web-data.zmlearn.com/image/CoQGB5BgKYc5tEJbgMhcm/img_p1_pic2%402x.png',
            },
            {
                id: 3,
                title: 'More Intelligent',
                content: 'Automatic recording and always available for review',
                img: 'https://web-data.zmlearn.com/image/tQoaowQHeW6zTbZAZ7zT84/img_p1_pic3%402x.png',
            },
        ]
    },
    platform: {
        title: '<h1><span>Immersive</span> and<p> Interactive</p> Teaching Platform</h1>',
        pcImg: 'https://web-data.zmlearn.com/image/6HuznNoBYyiGTqARqWxntN/img_P2%402x.png',
        padImg: 'https://web-data.zmlearn.com/image/muAcrh92vXKDSn1FLKp7qC/img_P2%402x.png',
        phoneImg: 'https://web-data.zmlearn.com/image/jaDVD6XoXYTtFgeJs4G2Wa/img_P2%402x.png',
        list: [
            {
                id: 1,
                title: 'Real-time Communication',
                img: 'https://web-data.zmlearn.com/image/ctUudq9ZqHNCHwY3aERuuP/icon_realtime%402x.png',
                pImg: 'https://web-data.zmlearn.com/image/nug5dhJEDEdFtHkVkXX8QL/icon_P2_realtime%402x.png'
            },
            {
                id: 2,
                title: 'Synchronous Practice',
                img: 'https://web-data.zmlearn.com/image/jnQHGN4DKzGfMjpDW2tPGh/icon_Synchronous%402x.png',
                pImg: 'https://web-data.zmlearn.com/image/iAwanTxBvNrLiPbVWGTtev/icon_P2_practice%402x.png'
            },
            {
                id: 3,
                title: 'Courseware Sharing',
                img: 'https://web-data.zmlearn.com/image/cgd6wP6DcPiEtJKCJVfLEJ/icon_Synchronous-1%402x.png',
                pImg: 'https://web-data.zmlearn.com/image/mXAXGbmAb18akyfBHuEGHn/icon_P2_share%402x.png'
            },
        ]
    },
    tutors: {
        title: '<h1><span>10,000+</span><p> Experienced</p> Tutors</h1>',
        list: [
            {
                id: 1,
                title: `<h4>10,000+ </h4>
                <span>Tutors</span>`,
                top: {
                    title: 'Adolph',
                    content: 'University of Cambridge',
                },
                bottom: [{
                    icon: 'https://web-data.zmlearn.com/image/kiKx2DQty2J9e3o8SpRjMQ/icon_subject%402x.png',
                    content: 'Subject: English',
                }, {
                    icon: 'https://web-data.zmlearn.com/image/ivsVrY3QtCkg7BZBzyrdPu/icon_grade%402x.png',
                    content: 'Grade: Y3-Y6',
                }, {
                    icon: 'https://web-data.zmlearn.com/image/tpGMffxT7FWfXnncbdBhkv/icon_time%402x.png',
                    content: 'Teaching Experience: 6 years',
                },],
                titleIcon: 'https://web-data.zmlearn.com/image/66EULkvQh26bQDaiGSrZxT/icon_teacher%402x.png',
                icon: 'https://web-data.zmlearn.com/image/kL6XMWRDqYsKEZMeXrXhjg/img_P3_glass%402x.png',
                img: 'https://web-data.zmlearn.com/image/8GXyTGHCv9cisFmGjWksFM/img_P3_adolph%402x.png',

            },
            {
                id: 2,
                title: `<h4>Top100 </h4>
                <span>Universities</span>`,
                top: {
                    title: 'Sophie',
                    content: 'Harvard University',
                },
                bottom: [{
                    icon: 'https://web-data.zmlearn.com/image/kiKx2DQty2J9e3o8SpRjMQ/icon_subject%402x.png',
                    content: 'Subject: Science',
                }, {
                    icon: 'https://web-data.zmlearn.com/image/ivsVrY3QtCkg7BZBzyrdPu/icon_grade%402x.png',
                    content: 'Grade: Grade3-Grade5',
                }, {
                    icon: 'https://web-data.zmlearn.com/image/tpGMffxT7FWfXnncbdBhkv/icon_time%402x.png',
                    content: 'Teaching Experience: 5 years',
                },],
                titleIcon: 'https://web-data.zmlearn.com/image/ceux1b624pSnrfai94gYoY/icon_Universities%402x.png',
                icon: 'https://web-data.zmlearn.com/image/u9psA7iCXSy7mdAbcqPDwW/img_P3_plane%402x.png',
                img: 'https://web-data.zmlearn.com/image/hQN7KkRuTQfNyyupdftWC4/img_P3_Sophie%402x.png',

            },
            {
                id: 3,
                title: `<h4>7.8%  </h4>
                <span>Pass Rate</span>`,
                top: {
                    title: 'Oscar',
                    content: 'University of Sydney',
                },
                bottom: [{
                    icon: 'https://web-data.zmlearn.com/image/kiKx2DQty2J9e3o8SpRjMQ/icon_subject%402x.png',
                    content: 'Subject: Mathmatics',
                }, {
                    icon: 'https://web-data.zmlearn.com/image/ivsVrY3QtCkg7BZBzyrdPu/icon_grade%402x.png',
                    content: 'Grade: Grade1-Grade6',
                }, {
                    icon: 'https://web-data.zmlearn.com/image/tpGMffxT7FWfXnncbdBhkv/icon_time%402x.png',
                    content: 'Teaching Experience: 6 years',
                },],
                titleIcon: 'https://web-data.zmlearn.com/image/3FhHKLh8SN9uShKZd6QSRp/icon_pass%402x.png',
                icon: 'https://web-data.zmlearn.com/image/6YDPq3NfTouUrp7MQxMHvJ/img_p3_light%402x.png',
                img: 'https://web-data.zmlearn.com/image/6WRgkopEiS6GKZgR7o57vE/img_P3_Oscar%402x.png',

            },
        ]
    },
    subject: {
        title: `<h1><span>All levels</span> and<p> All subjects</p> </h1>`,
        list: [
            {
                id: 1,
                countryIcon: 'https://web-data.zmlearn.com/image/vex3qEEYzJkYU4fX7bQ32q/_United%20Kingdom%402x.png',
                img: 'https://web-data.zmlearn.com/image/3kkfdQxmXtmhWcRJy9GcKB/img_P4_United%20Kingdom_2x.png',
                country: 'United Kingdom',
            },
            {
                id: 2,
                countryIcon: 'https://web-data.zmlearn.com/image/4XJVEmGmTvMx9HWTPaSJFK/United%20State%402x.png',
                img: 'https://web-data.zmlearn.com/image/h3PQiARqAa3bCDb7bR2mCS/img_P4_United%20State%402x%202.png',
                country: 'United State',
            },
            {
                id: 3,
                countryIcon: 'https://web-data.zmlearn.com/image/jSz1N9fMN8S3ibhFtUbTiT/Spain%402x.png',
                img: 'https://web-data.zmlearn.com/image/neLJ2mzoXetvgEttEKPTp4/img_P4_spain%402x.png',
                country: 'Spain',
            },
            {
                id: 4,
                countryIcon: 'https://web-data.zmlearn.com/image/xd3wY877ZitAtH5VenrTgK/AU%20-%20Australia%402x.png',
                img: 'https://web-data.zmlearn.com/image/77Mtwqf6tjgHw9vjc88rJt/img_P4_Australia%402x.png',
                country: 'Australia',
            },
            {
                id: 5,
                countryIcon: 'https://web-data.zmlearn.com/image/wJYYidrXjjP8AZTvH4KRhz/New%20Zeland%402x.png',
                img: 'https://web-data.zmlearn.com/image/rBnXLXd9kzmnqQ9HWhGYAY/img_P4_New%20Zeland%402x.png',
                country: 'New Zealand',
            },
            {
                id: 6,
                countryIcon: 'https://web-data.zmlearn.com/image/c3ieWw49a3mhLVohRhRsYT/CA%20-%20Canada%402x.png',
                img: 'https://web-data.zmlearn.com/image/bN62rcPXqb5E72n6SquKux/img_P4_Canada%402x.png',
                country: 'Canada',
            },
            {
                id: 7,
                countryIcon: 'https://web-data.zmlearn.com/image/3imjd3rNgUe22NW3kh7GD4/Malaysia%402x.png',
                img: 'https://web-data.zmlearn.com/image/hdkv6Le85bwNNzGBmJXZK1/img_P4_Malaysia%402x.png',
                country: 'Malaysia',
            },
            {
                id: 8,
                countryIcon: 'https://web-data.zmlearn.com/image/jHTXxvqjEJXSGtExy7xtES/Hong%20Kong%2C%20China%402x.png',
                img: 'https://web-data.zmlearn.com/image/pDg9EVe77XYMy6n4Zm2VgJ/img_P4_Hong%20Kong%2C%20China%402x.png',
                country: 'Hong Kong, China',
            },
            {
                id: 9,
                countryIcon: 'https://web-data.zmlearn.com/image/pN5A1LaGBpxHtTgnvHZ635/Singapore%402x.png',
                img: 'https://web-data.zmlearn.com/image/kgEciivuoVKpxsxZHfCK3N/img_P4_Singapore%402x.png',
                country: 'Singapore',
            },
        ]
    },
    works: {
        title: `<h1>How our<span> tailored</span> tutoring works</h1>`,
        list: [
            {
                id: 1,
                context: 'Before Class：Free Initial assessment, trial lesson and debriefing',
                icon: 'https://web-data.zmlearn.com/image/bF7mSzzsZWKB3EbzEEe2Th/%E7%BC%96%E7%BB%84%2028%402x.png',
            },
            {
                id: 2,
                context: 'In Class: Top tutors, interactive tools and courseware sharing',
                icon: 'https://web-data.zmlearn.com/image/8aeTnVvtNjzGbugdCCbSTT/icon_in%20class%402x.png',
            },
            {
                id: 3,
                context: 'After Class: Regular output analysis report and reviews of studying plan',
                icon: 'https://web-data.zmlearn.com/image/3Mta35ZvgsctVaGkRe1yk9/icon_after%20class%402x.png',
            },
        ]
    },
    grades: {
        title: `<h1><span>91%</span> of Students<p> Improved</p> Their Grades!</h1>`,
        commentText: '999+ Comments',
        list: [
            {
                id: 1,
                name: 'Amy',
                content: `My teacher doesn't just focus on academic subjects. She knows that they could be boring at times, so she incorporates some activities to make sure that I also hone some of my skills. For example, we play chess which helps me improve my problem solving and critical  thinking skills. And also she also give me tasks and materials which are different from at school and list my own reading lists to me. This helps me to perceive the topic from a different point of view making me understand the topic better. `,
                icon: 'https://web-data.zmlearn.com/image/jmp7nFSKojPMKHbDCYvnH1/icon_star_light%402x.png',
                img: 'https://web-data.zmlearn.com/image/w1n3gSBBmSgdC6oyGmuBmJ/img_P6_pic1%402x.png',
                dateText: '2nd, July,2021'
            },
            {
                id: 2,
                name: 'Mike',
                content: `This is what I have been waiting for. I was not very good at chemistry, which made me particularly worried before every exam. I had signed up for a chemistry course but the teacher was unable to tutor me one-to-one and I still couldn't keep up.Mike at AirClass is an excellent teacher, he was not only teaching me how to solve problems in chemistry, but also how to study chemistry. And I don't need one to one chemistry tutoring anymore, thank you so much airclass and Mikel!`,
                icon: 'https://web-data.zmlearn.com/image/jmp7nFSKojPMKHbDCYvnH1/icon_star_light%402x.png',
                img: 'https://web-data.zmlearn.com/image/2P6iGGUHb9bGig85LA4zin/img_P7_pic3%402x.png',
                dateText: '6th September, 2021'

            },
            {
                id: 3,
                name: 'James',
                content: `Purchasing Airclass sessions for my kid was the best decision I have made. The tutors keep my kid engaged and focused during his lessons.  They cater my son's individual needs by assessing his current level of understanding. Most importantly, my son really enjoys his lessons. Airclass has really helped my son with his science and maths and supported him to get the best possible grades.`,
                icon: 'https://web-data.zmlearn.com/image/jmp7nFSKojPMKHbDCYvnH1/icon_star_light%402x.png',
                img: 'https://web-data.zmlearn.com/image/3jRhGxtrsuZh5EgdKJWxGQ/img_P7_pic2%402x.png',
                dateText: '12th October, 2021'
            },
        ]

    }
}
